<!-- address component -->
<template>
  <div class="flex flex-col gap-y-5 overflow-y-auto h-full w-full ">
    <div class="flex items-center justify-between">
      <p class="font-medium text-xl">Select saved address</p>
      <p class="cta-link text-ellipsis line-clamp-1 text-sm font-medium" @click="handleAddEvent">Add address</p>
    </div>
    <UNotification id="1" :ui="{
      background: 'bg-gradient-to-b from-yellow-50 to-rose-100',
      description: 'text-gray-900 text-xs',
      shadow: 'shadow-none',
      rounded: 'rounded-xl',
      padding: 'p-4',
    }" :close-button="{ icon: '' }" :timeout="0" v-if="maxError">
      <template #description>
        <div class="flex items-center gap-x-3">
          <UIcon name="i-heroicons-exclamation-triangle" class="size-8 text-red-700" />
          <p>A maximum of {{ maxAllowed }} addresses can be added. To add a new one, you must delete an existing
            address.</p>
        </div>
      </template>
    </UNotification>
    <div class="flex min-h-48 w-full justify-center items-center" v-if="addressStore.loading">
      <V2LoaderIcon class="size-7 text-gray-500" />
    </div>
    <template v-else>
      <div class="flex flex-col items-center justify-center min-h-48 w-full text-center gap-4 py-6"
        v-if="addressStore.addresses.length === 0">
        <img src="/v2/images/Addressicon.png" alt="Address Icon" class="w-[200px] h-auto mx-auto" />
        <p class="text-gray-600 text-sm font-medium">
          No saved addresses found.
        </p>
      </div>

      <!-- <template v-if="addresses.length > 0" v-for="(address, idx) in addresses" :key="idx"> -->
      <template v-else v-for="(address, idx) in addressStore.addresses" :key="idx">
        <V2AddressPickerItem :data="address" @apply="setAddress" v-if="address" />
      </template>
    </template>
  </div>

</template>

<script setup lang="ts">
import { GoogleAnalytics } from '~/google_analytics/events';
import { EventParameter } from '~/google_analytics/events.enum';

const emit = defineEmits(['success', 'openAddAddress']);
const addressStore = useUserAddressStore();

const route = useRoute();
const { isAuthenticated } = useAuth();
const location = useLocation();
const geolocation = useGeoLocation();
// const addresses = ref([]);
const maxAllowed = ref(5);
const maxError = ref(false);

const setAddress = useDebounce(async (address: any) => {
  try {
    await geolocation.setDeliveryAddress(address);
    emit('success');
  } catch (error) {
    console.error("Error in setAddress:", error);
  }
}, 500);

const handleAddEvent = async () => {
  if (addressStore.addresses.length >= maxAllowed.value) {
    GoogleAnalytics.address({
      [EventParameter.ACTION]: 'add_new_address',
      [EventParameter.STATUS]: 'failed',
      [EventParameter.ERROR_MESSAGE]: 'address limit reached'
    });
    maxError.value = true;
    return;
  }
  // GoogleAnalytics.cta({
  //   [EventParameter.CTA_NAME]: 'add_address'
  // });
  GoogleAnalytics.address({
    [EventParameter.ACTION]: 'add_address',
    [EventParameter.STATUS]: 'initiated',
    [EventParameter.ERROR_MESSAGE]: 'no error'
  });
  sessionStorage.setItem("lastPageBeforeMap", route.fullPath);
  await navigateTo({ path: '/map', query: { from: 'cart' } });
  emit('openAddAddress');
};
</script>